import React from 'react';
import { EyeIcon, MapIcon, RocketIcon, BoxIcon } from 'lucide-react';
export function Curriculum() {
  const tracks = [{
    icon: EyeIcon,
    title: 'See Differently',
    subtitle: 'Strategic Mindset & FOMO → Confidence',
    color: 'from-cyan-500 to-blue-500',
    outcomes: ['Shift from fear and confusion to clarity and opportunity', "Audit your role, skills, and your company's position in the AI era", 'Recognize signal vs. noise in AI headlines and trends', 'Understand how to stay competitive and escape the "people pile"']
  }, {
    icon: MapIcon,
    title: 'Design Your AI Strategy',
    subtitle: 'Workflow OS & Roadmap',
    color: 'from-purple-500 to-pink-500',
    outcomes: ['Redesign your daily workflows with AI (email, docs, decision-making, research)', 'Turn vague AI aspirations into a concrete 90-day plan and 12-month roadmap', 'Build scenario plans that keep you ahead of disruption', 'Master your workflow and become your own strategy lead']
  }, {
    icon: BoxIcon,
    title: 'Build & Test with AI',
    subtitle: 'Labs & Prototypes',
    color: 'from-green-500 to-emerald-500',
    outcomes: ['Learn how to collaborate with AI as a research, strategy, and product partner', 'Build and test multiple prototypes with OpenAI, Claude, Perplexity, Google, Microsoft, Cohere', 'Understand how to trust, verify, and govern AI outputs', 'Master chain-of-thought prompting and catch AI hallucinations']
  }, {
    icon: RocketIcon,
    title: 'Lead the AI Shift',
    subtitle: 'Culture, Governance, Momentum',
    color: 'from-orange-500 to-red-500',
    outcomes: ['Speak about AI fluently with boards, investors, and teams', 'Redesign expectations, incentives, and culture around experimentation', 'Leave with a leadership playbook that extends far beyond "which tool to use"', 'Accelerate leadership fluency and create impact beyond tools']
  }];
  return <section className="py-24" data-id="element-58">
      <div className="max-w-7xl mx-auto px-6" data-id="element-59">
        <div className="text-center mb-16" data-id="element-60">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-61">
            The 4 Core Tracks
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-62">
            A comprehensive curriculum that transforms how you think, plan,
            build, and lead with AI
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-63">
          {tracks.map((track, index) => {
          const Icon = track.icon;
          return <div key={index} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8 hover:border-slate-700 transition-all duration-300" data-id="element-64">
                <div className={`w-16 h-16 bg-gradient-to-br ${track.color} rounded-xl flex items-center justify-center mb-6`} data-id="element-65">
                  <Icon className="w-8 h-8 text-white" data-id="element-66" />
                </div>

                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-67">
                  Track {index + 1}: {track.title}
                </h3>

                <p className="text-slate-400 mb-6" data-id="element-68">{track.subtitle}</p>

                <div className="space-y-3" data-id="element-69">
                  {track.outcomes.map((outcome, i) => <div key={i} className="flex items-start gap-3" data-id="element-70">
                      <div className="w-1.5 h-1.5 bg-cyan-400 rounded-full mt-2 flex-shrink-0" data-id="element-71"></div>
                      <p className="text-slate-300 text-sm" data-id="element-72">{outcome}</p>
                    </div>)}
                </div>
              </div>;
        })}
        </div>

        {/* Deliverables box */}
        <div className="bg-gradient-to-br from-cyan-900/30 to-purple-900/30 border border-cyan-500/30 rounded-2xl p-8" data-id="element-73">
          <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-74">
            You'll Leave With
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-75">
            <div className="text-center" data-id="element-76">
              <div className="text-3xl font-bold text-cyan-400 mb-2" data-id="element-77">
                90-Day
              </div>
              <p className="text-slate-300" data-id="element-78">AI Action Plan</p>
            </div>
            <div className="text-center" data-id="element-79">
              <div className="text-3xl font-bold text-purple-400 mb-2" data-id="element-80">
                12-Month
              </div>
              <p className="text-slate-300" data-id="element-81">Roadmap</p>
            </div>
            <div className="text-center" data-id="element-82">
              <div className="text-3xl font-bold text-green-400 mb-2" data-id="element-83">1–3</div>
              <p className="text-slate-300" data-id="element-84">Working Prototypes</p>
            </div>
            <div className="text-center" data-id="element-85">
              <div className="text-3xl font-bold text-orange-400 mb-2" data-id="element-86">
                Board-Ready
              </div>
              <p className="text-slate-300" data-id="element-87">AI Strategy Brief</p>
            </div>
            <div className="text-center" data-id="element-88">
              <div className="text-3xl font-bold text-pink-400 mb-2" data-id="element-89">
                Personal
              </div>
              <p className="text-slate-300" data-id="element-90">AI Learning Map</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}